
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'

export default class Sidebar extends React.Component {
  render() {
    return (
      <aside className='sidebar'>
        {this.props.children}
      </aside>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/Sidebar/index.js